import { FormControlLabel, Snackbar, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, ClickAwayListener } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import GetAppIcon from "@material-ui/icons/GetApp";
import MuiAlert from "@material-ui/lab/Alert";
import cn from "classnames";
import _, { upperCase } from "lodash";
import { FilterIcon, X } from "lucide-react";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  selectFilterCus,
  selectTagsPageSelected
} from "views/Customer/CustomerSelectors";
import customerApi from "../api/customerApi";
import ModalTagsBombot from "../components/Modals/ModalTagsBombot";
import types from "../constants/types";
import { createSearchQuery } from "../utils/helper";
import { setSearchUidName } from "../views/Customer/CustomerReducer";
import ButtonComponent from "./Button";
import FilterCustomerModal from "./FilterCustomer";
import Flex from "./Flex";
import FormDialog from "./FormDialog";
import TagPreviewItem from "./TagPreviewItem";
import TagsModal from "./TagPreviewModal";
import TagsManagementModal from "./TagsManagementModal/TagsManagementModal";
import { getCustomerAll } from "views/Customer/CustomerActions";
import styles from "./ListCustomer.module.scss";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AVATAR_COLORS = [
  "#16A34A","#2563EB","#7C3AED","#DB2777","#D97706","#0D9488","#DC2626","#4F46E5"
];
function getAvatarColor(name) {
  if (!name) return AVATAR_COLORS[0];
  let h = 0;
  for (const ch of name) h = (h * 31 + ch.charCodeAt(0)) % 997;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}

const useStyles = makeStyles((theme) => ({
  dialog: { borderRadius: "12px", maxWidth: "480px" },
  dialogTitle: { position: "relative" },
  closeButtonPopup: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  underline: {
    textDecoration: "none",
    fontWeight: 600,
    color: "#06ae34",
    borderBottom: "1px solid #06ae34",
    paddingBottom: "0.5px",
    "&:hover": { color: "#6c757d", borderBottom: "1px solid #6c757d" },
    "&:focus": { outline: "none" }
  },
  actionsConfirm: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    paddingTop: "5px"
  },
  campaignDialogContent: {
    padding: "24px 32px", minWidth: "480px",
    display: "flex", flexDirection: "column", gap: "20px", borderRadius: "12px"
  },
  campaignTitle: {
    fontWeight: 600, fontSize: "1.25rem", color: "#02af35", margin: 0, textAlign: "left"
  },
  campaignActions: {
    display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "10px", borderRadius: "12px"
  },
  btnCancel: {
    border: "1px solid #05AE34 !important",
    "&:hover": { backgroundColor: "#05AE34 !important" }
  },
  btnCancelOverride: { width: "100px !important", minWidth: "100px !important" },
  title: { color: "#05AE34" },
  p0: { padding: "0", margin: "0" },
  tagsContainer: { display: "flex", flexWrap: "wrap", gap: "4px", padding: "4px 0 !important" },
  buttonLoadMore: {
    alignItems: "center", appearance: "none", backgroundColor: "#fff",
    border: "1px solid #dbdbdb", borderRadius: ".375em", cursor: "pointer",
    display: "inline-flex", fontFamily: "inherit", fontSize: "0.8rem",
    height: "1.8em", justifyContent: "center", padding: "calc(.5em - 1px) 1em",
    position: "relative", textAlign: "center", userSelect: "none",
    touchAction: "manipulation", verticalAlign: "top", whiteSpace: "nowrap", width: "100%"
  },
  wrapBox: { padding: "15px", marginBottom: 30 },
  wrapButtonImport: { textAlign: "right" },
  wrapButtonPopup: { textAlign: "right", paddingBottom: 30, paddingRight: 15 },
  importInput: { margin: "15px 0px 30px 0px" },
  addTag: { width: "100%", marginBottom: 15 },
  buttonChange: { margin: "0px 0px 0px 10px" },
  wrapRadioGroup: { display: "inline-block", flexWrap: "inherit", flexDirection: "inherit", marginLeft: 15, fontSize: "16px", marginTop: 10 },
  icon: { marginLeft: 5, cursor: "pointer" },
  classTags: {}
}));

let timeout = 0;

export default function EnhancedTable(props) {
  const {
    data,
    handleGetData,
    getData,
    isPagination,
    isSearch,
    fanpageSelected,
    detail,
    edit,
    handleExport,
    handleRemoveCustomer,
    numCustomerRemove,
    handleImport,
    handleFilter,
    onCreate,
    customerAll,
    onCustomerCheck,
    onCustomerCheckReset,
    customerCheck,
    createCustomerSucss,
    paramsFilter,
    paramsPagination,
    getFanpage,
    customerState,
    fanpageFull,
    onChangeFanpage
  } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(types.PAGINATION.PAGE);
  const [rowsPerPage, setRowsPerPage] = useState(types.PAGINATION.SIZE);
  const [search, setSearch] = useState("");
  const [checkBoxSelectAll, setCheckBoxSelectAll] = useState(false);
  const [rows, setRows] = useState([]);
  const [isCreateCampaign, setIsCreateCampaign] = useState(false);
  const [openPopupConfirmCampaign, setOpenPopupConfirmCampaign] = useState(false);

  useEffect(() => {
    if (props.isCreateCampaign) {
      setIsCreateCampaign(true);
    }
  }, [props.isCreateCampaign]);
  const [titleCampaign, setTitleCampaign] = useState("");
  const [, setIsCheckedAllPage] = useState(false);
  const [selectedTags, setSeletedTags] = useState(null);
  const [isUseCheckedAllPage, setIsUseCheckedAllPage] = useState(false);
  const [customerAllState, setCustomerAllState] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [typeModalTag, setTypeModalTag] = useState(null);
  const [error, setError] = useState("");
  const [typeMessage, setTypeMessage] = useState(null);
  const [customerAfterFilter, setcustomerAfterFilter] = useState([]);
  const [showModalAllTags, setshowModalAllTags] = useState(false);
  const [selectedModalTags, setSelectedModalTags] = useState([]);
  const [isOpenModalManageTag, setIsOpenModalManageTag] = useState(false);
  const [isOpenModalFilter, setIsOpenModalFilter] = useState(false);
  const [isOpenModalConfirmRemoveCus, setIsOpenModalConfirmRemoveCus] = useState(false);
  const [kpiFilter, setKpiFilter] = useState("all"); // all | phone | untagged | fail
  const [comboOpen, setComboOpen] = useState(false);
  const [pageSearchText, setPageSearchText] = useState(""); // Để search fanpage
  const [sortVal, setSortVal] = useState("lastInboxTime,desc"); // valid sort fields: lastInboxTime, name, totalError
  const [filterPopOpen, setFilterPopOpen] = useState(false);
  const [condsDraft, setCondsDraft] = useState([{ field: '', op: '', val: '' }]);
  const [appliedConds, setAppliedConds] = useState([]);
  const [absoluteTotal, setAbsoluteTotal] = useState(0);
  const [toastMsg, setToastMsg] = useState(null);
  const toastTimer = useRef(null);
  const footerSelectRef = useRef(null);

  const DAY_OPTS = [
    [1, t('customer_page.day_opt', { count: 1 })],
    [3, t('customer_page.day_opt', { count: 3 })],
    [7, t('customer_page.day_opt', { count: 7 })],
    [14, t('customer_page.day_opt', { count: 14 })],
    [30, t('customer_page.day_opt', { count: 30 })],
    [60, t('customer_page.day_opt', { count: 60 })],
    [90, t('customer_page.day_opt', { count: 90 })],
  ];
  const FILTER_FIELDS = {
    gender:    { lbl: t('customer_page.filter_gender'),     ops: [['==', t('customer_page.op_is')], ['!=', t('customer_page.op_is_not')]] },
    phone:     { lbl: t('customer_page.filter_phone'),      ops: [['exists', t('customer_page.op_exists')], ['nexists', t('customer_page.op_not_exists')]] },
    fbtag:     { lbl: t('customer_page.filter_fb_tag'),     ops: [['in', t('customer_page.op_contains_tag')], ['notin', t('customer_page.op_not_contains_tag')]], isTag: 'fbTags' },
    bbtag:     { lbl: t('customer_page.filter_bb_tag'),     ops: [['in', t('customer_page.op_contains_tag')], ['notin', t('customer_page.op_not_contains_tag')]], isTag: 'bombotTags' },
    inbox:     { lbl: t('customer_page.filter_inbox'),      ops: [['within', t('customer_page.op_within')]], dayOpts: true },
    custInbox: { lbl: t('customer_page.filter_cust_inbox'), ops: [['within', t('customer_page.op_within')], ['exists', t('customer_page.op_exists')], ['nexists', t('customer_page.op_not_exists')]], dayOpts: true },
    failed:    { lbl: t('customer_page.filter_failed'),     ops: [['==', t('customer_page.op_eq')], ['>', t('customer_page.op_gt')], ['<', t('customer_page.op_lt')]] },
    canSend:   { lbl: t('customer_page.filter_can_send'), ops: [['yes', t('customer_page.op_can_send')], ['no', t('customer_page.op_cannot_send')]] },
  };
  const NO_VALUE_OPS = ['exists', 'nexists', 'yes', 'no'];

  const newCond = () => ({ field: '', op: '', val: '' });
  const updateCond = (i, patch) => setCondsDraft(prev => prev.map((c, idx) => idx === i ? { ...c, ...patch } : c));
  const removeCond = (i) => setCondsDraft(prev => { const next = prev.filter((_, idx) => idx !== i); return next.length ? next : [newCond()]; });

  const buildFullSearchQuery = (searchStr, conditions = appliedConds) => {
    if (!fanpageSelected?.id) return '';
    let query = '';
    conditions.forEach(c => {
      if (c.field === 'gender') {
        if ((c.op === '==' || c.op === '!=') && c.val) {
          query += `gender${c.op}${c.val};`;
        }
      } else if (c.field === 'phone') {
        if (c.op === 'exists') query += `phone=exists=true;`;
        else if (c.op === 'nexists') query += `phone=exists=false;`;
      } else if (c.field === 'canSend') {
        if (c.op === 'yes') query += `cannotReplyReason=exists=false;`;
        else if (c.op === 'no') query += `cannotReplyReason=exists=true;`;
      } else if (c.field === 'fbtag' || c.field === 'bbtag') {
        const fieldName = c.field === 'fbtag' ? 'fbTags' : 'bombotTags';
        if ((c.op === 'in' || c.op === 'notin') && c.val) {
          query += `${fieldName}=${c.op}=${c.val};`;
        }
      } else if (c.field === 'failed') {
        if ((c.op === '==' || c.op === '>' || c.op === '<') && c.val !== '' && c.val != null) {
          query += `totalError${c.op}${c.val};`;
        }
      } else if (c.field === 'inbox' || c.field === 'custInbox') {
        const fieldName = c.field === 'inbox' ? 'lastInboxTime' : 'lastCustomerInboxTime';
        if (c.op === 'exists') query += `${fieldName}=exists=true;`;
        else if (c.op === 'nexists') query += `${fieldName}=exists=false;`;
        else if (c.op === 'within' && c.val !== '' && c.val != null) {
          const days = parseInt(c.val, 10);
          if (Number.isFinite(days) && days >= 0) {
            const end = moment().format('YYYY-MM-DD');
            const start = moment().subtract(days, 'days').format('YYYY-MM-DD');
            query += `${fieldName}=bw=${start},${end};`;
          }
        }
      }
    });
    let baseQuery = query + `pageId==${fanpageSelected.id}`;
    if (searchStr) {
      baseQuery += `;uid|name==${searchStr}`;
    }
    return baseQuery;
  };

  const clearCustomerSelection = () => {
    setIsUseCheckedAllPage(false);
    setIsCheckedAllPage(false);
    setCheckBoxSelectAll(false);
    onCustomerCheckReset([]);
  };

  const applyFilterPop = () => {
    clearCustomerSelection();
    const valid = condsDraft.filter(c => c.field && c.op && (NO_VALUE_OPS.includes(c.op) || c.val !== ''));
    setAppliedConds(valid);
    if (fanpageSelected?.id) {
      const baseQuery = buildFullSearchQuery(search, valid);
      getData({ page: types.PAGINATION.PAGE, size: types.PAGINATION.SIZE, search: baseQuery, sort: sortVal });
      setPage(types.PAGINATION.PAGE);
    }
    setFilterPopOpen(false);
  };

  const resetFilterPop = () => {
    clearCustomerSelection();
    setCondsDraft([newCond()]);
    setAppliedConds([]);
    if (fanpageSelected?.id) {
      const baseQuery = buildFullSearchQuery(search, []);
      getData({ page: types.PAGINATION.PAGE, size: types.PAGINATION.SIZE, search: baseQuery, sort: sortVal });
      setPage(types.PAGINATION.PAGE);
    }
  };

  const tagsObj = useSelector(selectTagsPageSelected);
  const filterCus = useSelector(selectFilterCus);

  const [selectedPageId, setSelectedPageId] = useState(fanpageSelected?.id || null);

  let totalNumber = isUseCheckedAllPage
    ? (data && data.totalElements - customerCheck.length)
    : customerCheck.length;

  useEffect(() => {
    if (createCustomerSucss) setIsCreateCampaign(false);
  }, [createCustomerSucss]);

  // Close filter popover when clicking outside
  useEffect(() => {
    if (!filterPopOpen) return;
    const handler = () => setFilterPopOpen(false);
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [filterPopOpen]);

  useEffect(() => {
    setCustomerAllState(customerState?.content || []);
  }, [customerState?.content]);

  useEffect(() => {
    const items = (data && data.content) || [];
    const mappedItems = items.map(item => {
      const isInCheckList = customerCheck.some(c => c.id === item.id);
      return { ...item, checked: isUseCheckedAllPage ? !isInCheckList : isInCheckList };
    });
    setRows(mappedItems);
    const allCheckedOnPage = mappedItems.length > 0 && mappedItems.every(i => i.checked);
    setCheckBoxSelectAll(allCheckedOnPage);
  }, [data, customerCheck, isUseCheckedAllPage]);

  useEffect(() => {
    if (footerSelectRef.current) {
      footerSelectRef.current.indeterminate = isUseCheckedAllPage && customerCheck.length > 0;
    }
  }, [isUseCheckedAllPage, customerCheck.length]);

  useEffect(() => {
    if (fanpageSelected) {
      onCustomerCheckReset([]);
      setCheckBoxSelectAll(false);
      setIsCheckedAllPage(false);
      setIsUseCheckedAllPage(false);
    }
  }, [fanpageSelected]);

  useEffect(() => {
    // Capture absolute total when no filters are applied
    if (data?.totalElements !== undefined && appliedConds.length === 0 && !search && kpiFilter === 'all') {
      setAbsoluteTotal(data.totalElements);
    }
  }, [data?.totalElements, appliedConds.length, search, kpiFilter]);

  useEffect(() => {
    const searchParam = new URLSearchParams(window.location.search);
    const p = searchParam.get("page");
    if (p) setPage(_.toNumber(p) + 1);
  }, [paramsFilter]);

  // KPI derived values (from current page rows)
  const kpiTotal = data?.totalElements || 0;
  const kpiPhone = rows.filter(r => r.phone).length;
  const kpiUntagged = rows.filter(r => !r.bombotTags?.length && !r.fbTags?.length).length;
  const kpiFail = rows.filter(r => r.totalError > 0).length;
  const pct = n => rows.length ? Math.round((n / rows.length) * 100) + '%' : '0%';

  // Client-side sort for name (backend doesn't support nameText/name sort)
  const displayRows = sortVal === 'name,asc'
    ? [...rows].sort((a, b) => (a.name || '').localeCompare(b.name || '', 'vi', { sensitivity: 'base' }))
    : rows;

  const handleChangePage = (newPage) => {
    setPage(newPage);
    getData({
      page: newPage,
      size: rowsPerPage,
      search: buildFullSearchQuery(search, appliedConds),
      sort: sortVal
    });
  };

  const handleChangeRowsPerPage = (e) => {
    const sz = parseInt(e.target.value, 10);
    setRowsPerPage(sz);
    setPage(types.PAGINATION.PAGE);
    getData({
      page: types.PAGINATION.PAGE,
      size: sz,
      search: buildFullSearchQuery(search, appliedConds),
      sort: sortVal
    });
  };

  const handleChange = (event, value) => {
    const searchParam = new URLSearchParams(window.location.search);
    searchParam.set("page", value - 1);
    const searchStr = searchParam.get("search");
    history.push({ pathname: window.location.pathname, search: searchParam.toString() });
    paramsPagination({ page: value, size: rowsPerPage, pageId: fanpageSelected.id });
    setPage(value);
    if (filterCus?.search_string) {
      getData({ page: value - 1, size: 10, search: filterCus?.search_string, sort: sortVal });
    } else {
      getData({
        page: value - 1, size: rowsPerPage,
        search: buildFullSearchQuery(search, appliedConds),
        sort: sortVal
      });
    }
  };

  const handleSearch = (key, value) => {
    const customerFilter = customerAll.filter(
      cus => (cus.uid && cus.uid.includes(value)) || (cus.nameText && cus.nameText.includes(value))
    );
    setcustomerAfterFilter(customerFilter);
    dispatch(setSearchUidName(search));
    handleSubmitSearch();
  };

  const handleSubmitSearch = () => {
    clearCustomerSelection();
    if (fanpageSelected?.id) {
      const searchParam = new URLSearchParams(window.location.search);
      searchParam.set("page", types.PAGINATION.PAGE);
      searchParam.set("size", types.PAGINATION.SIZE);
      searchParam.set("pageId", `${fanpageSelected.id}`);
      searchParam.set("sort", sortVal);
      history.push({ pathname: window.location.pathname, search: searchParam.toString() });
      paramsPagination({ page: types.PAGINATION.PAGE, size: types.PAGINATION.SIZE, pageId: fanpageSelected.id });
      if (!_.isEmpty(fanpageSelected)) {
        const searchQuery = buildFullSearchQuery(search, appliedConds);
        getData({ page: types.PAGINATION.PAGE, size: types.PAGINATION.SIZE, search: searchQuery, sort: sortVal });
        setRowsPerPage(types.PAGINATION.SIZE);
        setPage(types.PAGINATION.PAGE);
      }
    }
  };

  const handleSubmitFilter = () => setIsOpenModalFilter(true);
  const toggleModalFilter = () => setIsOpenModalFilter(!isOpenModalFilter);
  const onSubmitFilter = (data) => setcustomerAfterFilter(data);
  const handleDetail = (item) => detail(item);
  const handleEdit = (item) => {
    const searchParam = new URLSearchParams(window.location.search);
    const getSearch = searchParam.get("search");
    const params = {
      page: types.PAGINATION.PAGE, size: types.PAGINATION.SIZE,
      search: `${getSearch ? getSearch : `pageId==${fanpageSelected.id}`};${search && `uid|name==` + search}`,
      sort: sortVal
    };
    edit(item, params);
  };
  const handleSubmitExport = () => handleExport();
  const handleSubmitRemoveCustomer = () => {
    if (isUseCheckedAllPage) {
      const uids = customerCheck.map((item) => item.uid).filter(Boolean);
      let activeSearch = buildFullSearchQuery(search, appliedConds);
      if (uids.length) activeSearch += `;uid=notin=${uids.join(",")}`;
      handleRemoveCustomer({ selectAllPages: true, search: activeSearch });
    } else {
      handleRemoveCustomer();
    }
    setIsOpenModalConfirmRemoveCus(!isOpenModalConfirmRemoveCus);
  };
  const handleToggleRemoveModal = () => setIsOpenModalConfirmRemoveCus(!isOpenModalConfirmRemoveCus);
  const handleSubmitImport = () => handleImport();
  const onKeyDown = (event) => { if (event.key === "Enter") handleSearch("search", search); };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleSelectAllClick = () => {
    let items = [];
    const isCurrentlyAllChecked = rows.length > 0 && rows.every(item => item.checked);
    if (isCurrentlyAllChecked) {
      rows.forEach(item => { if (item.checked) onCustomerCheck({ ...item, checked: isUseCheckedAllPage ? true : false }); items.push({ ...item, checked: false }); });
      setCheckBoxSelectAll(false);
    } else {
      rows.forEach(item => { if (!item.checked) onCustomerCheck({ ...item, checked: isUseCheckedAllPage ? false : true }); items.push({ ...item, checked: true }); });
      setCheckBoxSelectAll(true);
    }
    setRows(items);
  };

  const handleSelectCheckBox = (value) => {
    let items = [];
    rows.forEach(item => {
      if (item.id == value.id) {
        const payloadChecked = isUseCheckedAllPage ? value.checked : !value.checked;
        onCustomerCheck({ ...item, checked: payloadChecked });
        items.push({ ...item, checked: !value.checked });
      } else {
        items.push({ ...item });
      }
    });
    const allCheckedOnPage = items.length > 0 && items.every(i => i.checked);
    setCheckBoxSelectAll(allCheckedOnPage);
    setRows(items);
  };

  const handleSubmitCreate = () => setIsCreateCampaign(true);
  const handleCloseCreatePopup = () => {
    setIsCreateCampaign(false);
    setError("");
    setTitleCampaign("");
    if (props.onCloseCreateCampaign) props.onCloseCreateCampaign();
  };
  const handleSubmitCreateCampaign = () => {
    if (titleCampaign) setOpenPopupConfirmCampaign(true);
    else setError(t("update.error_msg_name_camp"));
  };
  const handleConfirmCreateCampaign = () => {
    const params = { name: titleCampaign, pageId: fanpageSelected.id };
    if (titleCampaign) {
      onCreate(
        paramsFilter,
        customerCheck,
        params,
        data,
        isUseCheckedAllPage,
        buildFullSearchQuery(search, appliedConds)
      );
      setError(""); setTitleCampaign(""); setIsCreateCampaign(false); setOpenPopupConfirmCampaign(false);
      if (props.onCloseCreateCampaign) props.onCloseCreateCampaign();
    } else {
      setError(t("update.error_msg_name_camp"));
    }
  };
  const handleClickExtension = (url) => { window.open(url, "_blank"); setOpenPopupConfirmCampaign(false); };
  const handleChangeCampaign = (key, value) => { if (key === "titleCampaign") setTitleCampaign(value); };
  const handleFooterSelectAll = () => {
    if (isUseCheckedAllPage && customerCheck.length === 0) {
      clearCustomerSelection();
      return;
    }
    setIsUseCheckedAllPage(true);
    setIsCheckedAllPage(true);
    onCustomerCheckReset([]);
  };
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  // Tính danh sách khách hàng đang được chọn (checked) để dùng khi mở modal tag
  const getSelectedCustomers = () => {
    if (isUseCheckedAllPage) {
      // Chọn tất cả trang: loại trừ những hàng bị bỏ chọn (customerCheck = danh sách uncheck)
      return rows.filter(r => !customerCheck.some(c => c.id === r.id));
    } else {
      // Chọn lẻ: customerCheck = danh sách checked
      return customerCheck;
    }
  };
  const openModalTag = (type) => { setTypeModalTag(type); handleCloseMenu(); };
  const onCloseModal = () => setTypeModalTag(null);
  const handleCloseShowModalAllTagsPopup = () => { setshowModalAllTags(false); setSelectedModalTags([]); };

  const handleRemoveTags = async (customer, removingTags) => {
    const payload = { search: `pageId==${customer.pageId}`, exclude: [], bombotTags: [...removingTags], include: [customer.uid] };
    return customerApi.unAttachTags(payload).then(() => {
      const searchParam = new URLSearchParams(window.location.search);
      const searchStr = searchParam.get("search");
      paramsPagination({ page, size: rowsPerPage, pageId: fanpageSelected.id });
      if (filterCus?.search_string) {
        getData({ page: page - 1, size: 10, search: filterCus?.search_string, sort: sortVal });
      } else {
        getData({ page: page - 1, size: rowsPerPage, search: buildFullSearchQuery(search, appliedConds), sort: sortVal });
      }
      getFanpage();
    });
  };

  let isEmptyCheckItem = rows.filter(item => !item.checked);

  const renderTagsCell = (tagList, type, row) => {
    let fanpageTags = {};
    let tagIds = [];
    const formattedColor = (color) => (color?.startsWith("#") ? color : `#${color}`);
    if (type === "partnerTag") {
      fanpageTags = tagsObj?.partnerTags || {};
      tagList?.forEach(group => group?.tags?.forEach(tagId => tagIds.push(tagId)));
    } else {
      fanpageTags = type === "bombotTag" ? tagsObj?.bombotTags : type === "fbTag" ? tagsObj?.fbTags : {};
      tagIds = tagList || [];
    }
    const filterTags = tagIds.filter(tagId => fanpageTags?.[tagId]);
    return (
      <>
        {filterTags.length ? (
          <div className={classes.tagsContainer}>
            {filterTags.slice(0, 2).map((tagId, index) => {
              const tag = fanpageTags[tagId];
              const tagName = tag?.system ? `${tag.system}: ${tag.name}` : tag.name;
              return tagName && (
                <TagPreviewItem
                  key={index}
                  styleText={{ maxWidth: "110px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                  background={tag?.backgroundColor || formattedColor(tag?.color)}
                  color={tag?.textColor || "#FFF"}
                  name={tagName}
                  size="small"
                />
              );
            })}
          </div>
        ) : (
          <span className={styles.tagNone}>—</span>
        )}
        {filterTags.length > 2 && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              const selectedTagObjects = filterTags.map(tagId => fanpageTags[tagId]);
              setSeletedTags({ tagList: selectedTagObjects, customer: row, type });
            }}
            className={cn(styles.tagMini, styles.tagMore)}
          >
            +{filterTags.length - 2}
          </button>
        )}
      </>
    );
  };

  // Pagination helper
  const totalPages = Math.max(1, Math.ceil((data?.totalElements || 0) / rowsPerPage));
  const currentPage = page === 0 ? 1 : page;

  const getPaginationPages = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [1];
    if (currentPage > 3) pages.push("…");
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) pages.push(i);
    if (currentPage < totalPages - 2) pages.push("…");
    pages.push(totalPages);
    return pages;
  };

  const copyText = (text, e) => {
    e.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(String(text));
      setToastMsg(t('fanpage_page.copy_success', { id: text }));
      if (toastTimer.current) clearTimeout(toastTimer.current);
      toastTimer.current = setTimeout(() => setToastMsg(null), 2500);
    }
  };

  const genderLabel = (g) => {
    if (!g) return "—";
    if (_.upperCase(g) === _.upperCase(types.GENDER.MALE)) return t("update.gender.male");
    if (_.upperCase(g) === _.upperCase(types.GENDER.FEMALE)) return t("update.gender.female");
    return t("update.gender.other");
  };

  return (
    <>
      {typeMessage && (
        <Snackbar open={typeMessage != null} anchorOrigin={{ horizontal: "center", vertical: "top" }} autoHideDuration={6000}>
          <Alert onClose={() => {}} severity={typeMessage}>
            {typeMessage === "error" ? t("update.error_msg") : t("customer_management.import_customer.import_result.success")}
          </Alert>
        </Snackbar>
      )}

      {/* Create Campaign modal */}
      <FormDialog isOpen={isCreateCampaign} width="440px" withoutHeader handleClose={() => handleCloseCreatePopup()}>
        <div>
          {/* Modal Header */}
          <div className={styles.modalHd}>
            <div className={styles.modalTitle}>{t("customer_management.create_campaign.title")}</div>
            <button className={styles.modalClose} onClick={() => handleCloseCreatePopup()}>
              <svg viewBox="0 0 14 14"><path d="M3 3l8 8M11 3l-8 8"/></svg>
            </button>
          </div>

          {/* Modal Body */}
          <div className={styles.modalBd}>
            <div className={styles.formField}>
              <label className={styles.formLbl}>{t('customer_page.campaign_name_label')}</label>
              <input
                className={styles.formInput}
                placeholder={t('customer_management.create_campaign.create_campaign_name')}
                autoFocus
                value={titleCampaign}
                onChange={(e) => { handleChangeCampaign("titleCampaign", e.target.value); if (error) setError(""); }}
                onKeyDown={(e) => { if (e.key === "Enter") handleSubmitCreateCampaign(); }}
              />
              {error && <span style={{ color: "red", fontSize: 11, marginTop: 2 }}>{error}</span>}
            </div>
            <div className={styles.formNote} style={{ marginTop: 10 }}>
              <svg viewBox="0 0 14 14"><circle cx="7" cy="7" r="5.5"/><path d="M7 6.5v3M7 4.5h.01"/></svg>
              <span>
                {totalNumber > 0
                  ? t('customer_page.campaign_note_selected', { count: totalNumber.toLocaleString("vi-VN") })
                  : t('customer_page.campaign_note_filter')}
              </span>
            </div>
          </div>

          {/* Modal Footer */}
          <div className={styles.modalFt}>
            <button className={cn(styles.btn, styles.btnGhost)} onClick={() => handleCloseCreatePopup()}>
              {t("common.btn.cancel") || "Huỷ"}
            </button>
            <button className={cn(styles.btn, styles.btnPrimary)} onClick={() => handleSubmitCreateCampaign()}>
              {t("common.btn.create") || "Tạo"}
            </button>
          </div>
        </div>
      </FormDialog>

      {/* Extension dialog for campaign (Kiểm tra cài đặt BomBot) */}
      <FormDialog isOpen={openPopupConfirmCampaign} width="450px" withoutHeader handleClose={() => setOpenPopupConfirmCampaign(false)}>
        <div>
          {/* Close button */}
          <button
            onClick={() => setOpenPopupConfirmCampaign(false)}
            style={{ position: 'absolute', top: 12, right: 12, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-tertiary, #9CA3AF)', padding: 4, borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 16, height: 16 }}><path d="M3 3l8 8M11 3l-8 8"/></svg>
          </button>

          {/* Icon */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '28px 24px 0' }}>
            <div style={{
              width: 56, height: 56, borderRadius: '50%',
              background: 'var(--green-light, #DCFCE7)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              marginBottom: 14,
            }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="var(--green-dark, #16A34A)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 26, height: 26 }}>
                <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                <path d="M2 12l10 5 10-5"/>
                <path d="M2 17l10 5 10-5"/>
              </svg>
            </div>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary, #111827)', marginBottom: 8, textAlign: 'center' }}>
              {t('customer_page.ext_check_title')}
            </div>
            <p style={{ fontSize: 13, lineHeight: 1.7, color: 'var(--text-secondary, #6B7280)', textAlign: 'center', margin: '0 0 20px' }}>
              {t('common.btn.instruction1')}{' '}
              <a
                href="https://hotro.bombot.vn/knowledgebase/huong-dan-cai-dat-phien-ban-moi-ung-dung-gui-tin-hang-loat-bombot-vn/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--green-dark, #16A34A)', fontWeight: 600, textDecoration: 'none' }}
                onClick={() => setOpenPopupConfirmCampaign(false)}
              >
                {t('common.btn.see_detail')}
              </a>{' '}
              {t('common.btn.instruction2')}
            </p>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', gap: 10, padding: '0 24px 24px' }}>
            <button
              onClick={() => handleClickExtension(types.URL.EXTENSION)}
              style={{
                flex: 1, padding: '10px 0', border: '1px solid var(--border, #E5E7EB)',
                background: 'var(--surface, #fff)', borderRadius: 8,
                fontSize: 13, fontWeight: 600, color: 'var(--text-secondary, #6B7280)',
                cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                transition: 'all 0.12s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--green, #22C55E)'; e.currentTarget.style.color = 'var(--green-dark, #16A34A)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border, #E5E7EB)'; e.currentTarget.style.color = 'var(--text-secondary, #6B7280)'; }}
            >
              <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.8" style={{ width: 14, height: 14, flexShrink: 0 }}>
                <path d="M7 2v8m0 0l-3-3m3 3l3-3M2 11.5v.5A1.5 1.5 0 003.5 13.5h7A1.5 1.5 0 0012 12v-.5"/>
              </svg>
              {t('common.btn.install_download_file')}
            </button>
            <button
              onClick={handleConfirmCreateCampaign}
              style={{
                flex: 1, padding: '10px 0', border: 'none',
                background: 'var(--green, #22C55E)', borderRadius: 8,
                fontSize: 13, fontWeight: 700, color: '#fff',
                cursor: 'pointer', fontFamily: 'inherit',
                transition: 'background 0.12s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'var(--green-dark, #16A34A)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'var(--green, #22C55E)'; }}
            >
              {t('common.btn.continue')} →
            </button>
          </div>
        </div>
      </FormDialog>

      {/* All tags modal */}
      <FormDialog isOpen={showModalAllTags} handleClose={() => handleCloseShowModalAllTagsPopup()}>
        <div style={{ padding: "10px" }}>
          <h4 className={classes.title}>{t("customer_management.tags.list_title")}</h4>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {(selectedModalTags || []).map((tag, idx) => {
              if (!tag) return null;
              return (
                <div key={idx} style={{ width: "50%", padding: "10px" }}>
                  <span className={classes.classTags} style={{ background: `#${tag.color?.replace("#", "")}`, color: tag.color === "000000" ? "white" : "", fontSize: "0.8125rem", marginBottom: 3, borderRadius: 16, padding: "2px 5px", display: "block", boxSizing: "border-box", width: "100%" }}>
                    {tag.system ? `${tag.system}: ${tag.name}` : tag.name}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </FormDialog>

      {/* Update-info menu */}
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleCloseMenu} elevation={0} getContentAnchorEl={null} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} transformOrigin={{ vertical: "top", horizontal: "center" }}>
        <MenuItem onClick={() => openModalTag("add")}>{t("customer_management.add_bombot_tag.title")}</MenuItem>
        <MenuItem onClick={() => openModalTag("edit")}>{t("customer_management.remove_bombot_tag.title")}</MenuItem>
      </Menu>

      {/* ===== KPI ROW ===== */}
      <div className={styles.kpiRow}>
        <div className={cn(styles.kpiCard, { [styles.selected]: kpiFilter === "all" })} onClick={() => setKpiFilter("all")}>
          <div className={styles.kpiTop}>
            <div className={cn(styles.kpiIcon, styles.iTotal)}>
              <svg viewBox="0 0 18 18" fill="none"><circle cx="6" cy="6" r="2.5"/><path d="M1.5 15c0-2.8 2-4.5 4.5-4.5s4.5 1.7 4.5 4.5"/><path d="M11 2.3a2.5 2.5 0 010 4.9M14.5 15c0-2.2-1.3-3.8-3-4.3"/></svg>
            </div>
          </div>
          <div className={styles.kpiVal}>{(absoluteTotal || 0).toLocaleString("vi-VN")}</div>
          <div className={styles.kpiLbl}>{t('customer_page.kpi_total')}</div>
        </div>
        <div className={cn(styles.kpiCard, { [styles.selected]: kpiFilter === "phone" })} onClick={() => setKpiFilter("phone")}>
          <div className={styles.kpiTop}>
            <div className={cn(styles.kpiIcon, styles.iPhone)}>
              <svg viewBox="0 0 18 18" fill="none"><path d="M11 1.5H7a1.5 1.5 0 00-1.5 1.5v12A1.5 1.5 0 007 16.5h4a1.5 1.5 0 001.5-1.5V3A1.5 1.5 0 0011 1.5z"/><circle cx="9" cy="14" r="0.6" fill="currentColor"/></svg>
            </div>
          </div>
          <div className={styles.kpiVal}>{kpiPhone}<small> · {pct(kpiPhone)}</small></div>
          <div className={styles.kpiLbl}>{t('customer_page.kpi_phone')}</div>
        </div>
        <div className={cn(styles.kpiCard, { [styles.selected]: kpiFilter === "untagged" })} onClick={() => setKpiFilter("untagged")}>
          <div className={styles.kpiTop}>
            <div className={cn(styles.kpiIcon, styles.iTag)}>
              <svg viewBox="0 0 18 18" fill="none"><path d="M2 2h6l7 7-6 6-7-7V2z"/><circle cx="5.5" cy="5.5" r="1" fill="currentColor"/></svg>
            </div>
          </div>
          <div className={styles.kpiVal}>{kpiUntagged}<small> · {pct(kpiUntagged)}</small></div>
          <div className={styles.kpiLbl}>{t('customer_page.kpi_untagged')}</div>
        </div>
        <div className={cn(styles.kpiCard, styles.kpiAlert, { [styles.selected]: kpiFilter === "fail" })} onClick={() => setKpiFilter("fail")}>
          <div className={styles.kpiTop}>
            <div className={cn(styles.kpiIcon, styles.iWarn)}>
              <svg viewBox="0 0 18 18" fill="none"><path d="M9 2L1.5 15h15L9 2z"/><path d="M9 7v4M9 13h.01"/></svg>
            </div>
          </div>
          <div className={styles.kpiVal}>{kpiFail}</div>
          <div className={styles.kpiLbl}>{t('customer_page.kpi_fail')}</div>
        </div>
      </div>

      {/* ===== TABLE CARD ===== */}
      <div className={styles.card}>

        {/* TOOLBAR */}
        <div className={styles.toolbar}>
          {/* Fanpage combo */}
          <ClickAwayListener
            onClickAway={() => {
              setComboOpen(false);
              setPageSearchText("");
            }}
          >
            <div className={styles.comboWrap} id="fanpage_select">
              <svg className={styles.comboIcon} viewBox="0 0 15 15" fill="none"><path d="M3 1.5v12M3 1.5h8l-1.5 2.5L11 6.5H3"/></svg>
              <input
                className={styles.comboInput}
                placeholder={fanpageSelected?.name || t('customer_page.combo_placeholder')}
                value={comboOpen ? pageSearchText : (fanpageSelected?.name || "")}
                onChange={(e) => setPageSearchText(e.target.value)}
                onFocus={() => {
                  setComboOpen(true);
                  setPageSearchText("");
                }}
                onClick={() => {
                  if (!comboOpen) {
                    setComboOpen(true);
                    setPageSearchText("");
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Escape") {
                    setComboOpen(false);
                    setPageSearchText("");
                  }
                }}
                autoComplete="off"
              />
              <svg className={styles.comboCaret} viewBox="0 0 12 12" fill="none"><path d="M3 5l3 3 3-3"/></svg>
              <div
                className={cn(styles.comboList, { [styles.open]: comboOpen })}
                onMouseDown={(e) => e.preventDefault()}
              >
                {(() => {
                  const searchTrim = pageSearchText.trim().toLowerCase();
                  const filtered = fanpageFull?.filter(fp => {
                    if (!searchTrim) return true;
                    return (
                      fp.name?.toLowerCase().includes(searchTrim) ||
                      fp.id?.toString().includes(searchTrim)
                    );
                  }) || [];
                  
                  return filtered.length > 0 ? (
                    filtered.map((fp) => (
                      <div
                        key={fp.id}
                        className={cn(styles.comboOpt, { [styles.sel]: fp.id === fanpageSelected?.id })}
                        onClick={() => {
                          if (onChangeFanpage) onChangeFanpage(fp);
                          setComboOpen(false);
                          setPageSearchText("");
                        }}
                      >
                        <span>{fp.name}</span>
                        <small>{fp.id}</small>
                      </div>
                    ))
                  ) : (
                    <div className={styles.comboEmpty}>{t('update.no_data')}</div>
                  );
                })()}
              </div>
            </div>
          </ClickAwayListener>

          {/* Search */}
          <div className={styles.searchWrap}>
            <svg className={styles.searchIcon} viewBox="0 0 14 14" fill="none"><circle cx="6.5" cy="6.5" r="4.5"/><path d="M13 13l-3-3"/></svg>
            <input
              className={styles.searchInput}
              id="searchInput"
              placeholder={t("customer_management.search")}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={onKeyDown}
            />
          </div>

          <button className={cn(styles.btn, styles.btnPrimary)} onClick={() => handleSearch("search", search)}>
            <svg viewBox="0 0 14 14" fill="none"><circle cx="6.5" cy="6.5" r="4.5"/><path d="M13 13l-3-3"/></svg>
            {t('common.btn.search')}
          </button>

          {/* Sort */}
          <select className={styles.sortSelect} value={sortVal} onChange={(e) => {
            const val = e.target.value;
            setSortVal(val);
            if (val === 'name,asc') return;
            if (fanpageSelected?.id) {
              const searchQuery = buildFullSearchQuery(search, appliedConds);
              getData({ page: types.PAGINATION.PAGE, size: types.PAGINATION.SIZE, search: searchQuery, sort: val });
              setPage(types.PAGINATION.PAGE);
            }
          }}>
            <option value="lastInboxTime,desc">{t('customer_page.sort_inbox_newest')}</option>
            <option value="lastInboxTime,asc">{t('customer_page.sort_inbox_oldest')}</option>
            <option value="name,asc">{t('fanpage_page.sort_name_az')}</option>
            <option value="totalError,desc">{t('customer_page.sort_fail_most')}</option>
          </select>

          {/* Filter button + Popover */}
          <div className={styles.filterBtnWrap} id="filter_customer">
            <button
              className={cn(styles.btn, styles.btnGhost, { [styles.btnActive]: filterPopOpen || appliedConds.length > 0 })}
              onClick={(e) => { e.stopPropagation(); setFilterPopOpen(v => !v); if (!filterPopOpen) setCondsDraft(appliedConds.length ? appliedConds.map(c => ({ ...c })) : [newCond()]); }}
            >
              <svg viewBox="0 0 14 14" fill="none"><path d="M1.5 2.5h11l-4.2 5v4l-2.6-1.5V7.5l-4.2-5z"/></svg>
              {t('customer_page.btn_filter')}
              {appliedConds.length > 0 && <span className={styles.filterBadge}>{appliedConds.length}</span>}
            </button>

            {filterPopOpen && (
              <div className={styles.filterPop} onClick={e => e.stopPropagation()}>
                <div className={styles.fpTitle}>{t('customer_page.filter_title')}</div>
                <div className={styles.condList}>
                  {condsDraft.map((c, i) => (
                    <div key={i} className={styles.condRow}>
                      {/* Field */}
                      <select className={styles.fpSelect} value={c.field} onChange={e => updateCond(i, { field: e.target.value, op: '', val: '' })}>
                        <option value="">{t('customer_page.select_field')}</option>
                        {Object.entries(FILTER_FIELDS).map(([k, f]) => <option key={k} value={k}>{f.lbl}</option>)}
                      </select>
                      {/* Operator */}
                      <select className={styles.fpSelect} value={c.op} disabled={!c.field} onChange={e => updateCond(i, { op: e.target.value, val: '' })}>
                        <option value="">{t('customer_page.select_op')}</option>
                        {c.field && FILTER_FIELDS[c.field].ops.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                      </select>
                      {/* Value */}
                      {(!c.field || NO_VALUE_OPS.includes(c.op)) ? (
                        <select className={styles.fpSelect} disabled><option>—</option></select>
                      ) : c.field === 'failed' ? (
                        <input className={styles.fpInput} type="number" min="0" placeholder={t('customer_page.enter_number')} value={c.val} onChange={e => updateCond(i, { val: e.target.value })} />
                      ) : c.field === 'gender' ? (
                        <select className={styles.fpSelect} value={c.val} onChange={e => updateCond(i, { val: e.target.value })}>
                          <option value="">{t('customer_page.select_value')}</option>
                          <option value="MALE">{t('update.gender.male')}</option>
                          <option value="FEMALE">{t('update.gender.female')}</option>
                          <option value="NEUTER">{t('update.gender.other')}</option>
                        </select>
                      ) : FILTER_FIELDS[c.field]?.isTag ? (
                        <select className={styles.fpSelect} value={c.val} onChange={e => updateCond(i, { val: e.target.value })}>
                          <option value="">{t('customer_page.select_tag')}</option>
                          {Object.values(tagsObj?.[FILTER_FIELDS[c.field].isTag] || {}).map(tag => (
                            <option key={tag.id} value={tag.id}>{tag.name}</option>
                          ))}
                        </select>
                      ) : FILTER_FIELDS[c.field]?.dayOpts ? (
                        <select className={styles.fpSelect} value={c.val} onChange={e => updateCond(i, { val: e.target.value })}>
                          <option value="">{t('customer_page.select_period')}</option>
                          {DAY_OPTS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                        </select>
                      ) : (
                        <select className={styles.fpSelect} disabled><option>—</option></select>
                      )}
                      {/* Remove */}
                      <button className={styles.condRemove} onClick={() => removeCond(i)} title={t('customer_management.customer_filter.delete')}>
                        <svg viewBox="0 0 14 14" fill="none"><path d="M3 3l8 8M11 3l-8 8"/></svg>
                      </button>
                    </div>
                  ))}
                </div>
                <button className={styles.btnAddCond} onClick={() => setCondsDraft(prev => [...prev, newCond()])}>
                  <svg viewBox="0 0 14 14" fill="none"><path d="M7 2v10M2 7h10"/></svg>
                  {t('common.btn.add_condition')}
                </button>
                <div className={styles.condHint}>{t('customer_page.filter_hint')}</div>
                <div className={styles.fpActions}>
                  <button className={cn(styles.btn, styles.btnGhost)} onClick={resetFilterPop}>{t('common.btn.reset')}</button>
                  <button className={cn(styles.btn, styles.btnPrimary)} onClick={applyFilterPop}>{t('common.btn.apply')}</button>
                </div>
              </div>
            )}
          </div>

        </div>

        {/* FILTER CHIPS */}
        <div className={styles.filterRow}>
          <div className={cn(styles.chip, { [styles.on]: kpiFilter === "all" })} onClick={() => setKpiFilter("all")}>{t('fanpage_page.filter_all')} <span className={styles.chipCount}>({kpiTotal})</span></div>
          <div className={cn(styles.chip, { [styles.on]: kpiFilter === "phone" })} onClick={() => setKpiFilter("phone")}>{t('customer_page.chip_phone')} <span className={styles.chipCount}>({kpiPhone})</span></div>
          <div className={cn(styles.chip, { [styles.on]: kpiFilter === "untagged" })} onClick={() => setKpiFilter("untagged")}>{t('customer_page.chip_untagged')} <span className={styles.chipCount}>({kpiUntagged})</span></div>
          <div className={cn(styles.chip, styles.chipRed, { [styles.on]: kpiFilter === "fail" })} onClick={() => setKpiFilter("fail")}>{t('customer_page.chip_fail')} <span className={styles.chipCount}>({kpiFail})</span></div>
        </div>

        {/* SELECTION BAR */}
        <div className={cn(styles.selBar, { [styles.show]: totalNumber > 0 })}>
          <span className={styles.selCount}>{t('customer_page.selected_count', { count: totalNumber > 0 ? totalNumber : 0 })}</span>
          <span className={styles.selClear} onClick={() => { onCustomerCheckReset([]); setIsUseCheckedAllPage(false); setIsCheckedAllPage(false); }}>{t('customer_page.deselect')}</span>
          <span className={styles.selSpacer}></span>
          <button className={cn(styles.btn, styles.btnGhost, styles.btnSm)} onClick={() => openModalTag("add")}>
            <svg viewBox="0 0 14 14" fill="none"><path d="M2 2h5l5 5-5 5-5-5V2z"/><circle cx="4.5" cy="4.5" r="0.5" fill="currentColor"/></svg>
            {t('customer_page.btn_add_tag')}
          </button>
          <button className={cn(styles.btn, styles.btnGhost, styles.btnSm)} onClick={() => openModalTag("edit")}>
            <svg viewBox="0 0 14 14" fill="none"><path d="M2 2h5l5 5-5 5-5-5V2z"/><path d="M4 10l6-6" strokeWidth="1.6"/></svg>
            {t('customer_page.btn_remove_tag')}
          </button>
          <button className={cn(styles.btn, styles.btnPrimary, styles.btnSm)} onClick={handleSubmitCreate} disabled={_.isEmpty(fanpageSelected)}>
            <svg viewBox="0 0 14 14" fill="none"><path d="M7 2v10M2 7h10"/></svg>
            {t('customer_management.create_campaign.title')}
          </button>
          <button className={cn(styles.btn, styles.btnDangerGhost, styles.btnSm)} onClick={totalNumber <= 0 ? undefined : handleToggleRemoveModal}>
            <svg viewBox="0 0 14 14" fill="none"><path d="M2.5 4h9M5.5 4V2.5h3V4M4 4l.5 8h5l.5-8"/></svg>
            {t('customer_page.btn_delete')} ({totalNumber > 0 ? totalNumber : 0})
          </button>
        </div>

        {/* TABLE */}
        <div className={styles.tblScroll}>
          {displayRows.length > 0 ? (
            <table className={styles.customTable}>
              <thead>
                <tr>
                  <th className={styles.thChk}>
                    <input
                      type="checkbox"
                      className={styles.chk}
                      checked={isEmptyCheckItem.length > 0 ? false : checkBoxSelectAll}
                      onChange={handleSelectAllClick}
                    />
                  </th>
                  <th>{t('customer_page.col_customer')}</th>
                  <th>{t('customer_page.col_gender')}</th>
                  <th>{t('customer_page.col_phone')}</th>
                  <th>{t('customer_page.col_tag')}</th>
                  <th>{t('customer_page.col_last_inbox')}</th>
                  <th>{t('customer_page.col_fail_send')}</th>
                  <th style={{ width: 52 }}></th>
                </tr>
              </thead>
              <tbody>
                {displayRows.map((row, index) => {
                  const isKpiMatch =
                    kpiFilter === "all" ||
                    (kpiFilter === "phone" && row.phone) ||
                    (kpiFilter === "untagged" && (!row.bombotTags?.length && !row.fbTags?.length)) ||
                    (kpiFilter === "fail" && row.totalError > 0);
                  if (!isKpiMatch) return null;
                  return (
                    <tr key={row.uid || index} className={cn(styles.custRow, { [styles.checked]: row.checked })}>
                      <td className={styles.tdChk}>
                        <input
                          type="checkbox"
                          className={styles.chk}
                          checked={row.checked}
                          onChange={() => handleSelectCheckBox(row)}
                        />
                      </td>
                      <td>
                        <div className={styles.custCell}>
                          <div className={styles.custAvatar} style={{ background: getAvatarColor(row.name) }}>
                            {row.name ? row.name.charAt(0).toUpperCase() : "?"}
                          </div>
                          <div className={styles.custMeta}>
                            <div className={styles.custName} title={row.name}>{row.name || "—"}</div>
                            {row.uid && (
                              <div className={styles.custUid}>
                                <span>{row.uid}</span>
                                <button className={styles.copyBtn} onClick={(e) => copyText(row.uid, e)} title={t('customer_page.copy_uid')}>
                                  <svg viewBox="0 0 12 12" fill="none"><rect x="3" y="3" width="7" height="7" rx="1"/><path d="M2 8V2h6"/></svg>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                      <td><span className={styles.genderTxt}>{genderLabel(row.gender)}</span></td>
                      <td>
                        {row.phone
                          ? <span className={styles.phoneCell}>{row.phone}</span>
                          : <span className={styles.phoneNone}>—</span>}
                      </td>
                      <td>
                        <div className={styles.tagsCell}>
                          {renderTagsCell(row?.fbTags, "fbTag", row)}
                          {renderTagsCell(row?.bombotTags, "bombotTag", row)}
                        </div>
                      </td>
                      <td>
                        {row.lastInboxTime ? (
                          <div className={styles.timeCell}>
                            <span className={styles.timeMain}>{moment(row.lastInboxTime).format("DD/MM/YYYY")}</span>
                            <span className={styles.timeSub}>{moment(row.lastInboxTime).format("HH:mm")}</span>
                          </div>
                        ) : <span className={styles.phoneNone}>—</span>}
                      </td>
                      <td>
                        {row.totalError > 0
                          ? <span className={styles.failBadge}>⚠ {row.totalError} {t('customer_page.fail_times')}</span>
                          : <span className={styles.failZero}>0</span>}
                      </td>
                      <td>
                        <button className={styles.rowAction} title={t('customer_page.btn_edit')} onClick={() => handleEdit(row)}>
                          <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M10 2l2 2-7.5 7.5L2 12l.5-2.5L10 2z"/></svg>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className={styles.tblEmpty}>
              <div className={styles.tblEmptyIcon}>
                <svg viewBox="0 0 20 20" fill="none"><circle cx="9" cy="9" r="6"/><path d="M17 17l-4-4"/></svg>
              </div>
              <div className={styles.tblEmptyTitle}>{t("customer_page.empty_title")}</div>
              <div className={styles.tblEmptySub}>{t("customer_page.empty_sub")}</div>
              <button className={cn(styles.btn, styles.btnGhost)} onClick={() => {setSearch(""); setKpiFilter("all"); setSortVal("lastInboxTime,desc"); handleSearch("search", "");}}>{t("customer_page.btn_clear_filter")}</button>
            </div>
          )}
        </div>

        {/* FOOTER PAGINATION */}
        {isPagination && rows.length > 0 && (
          <div className={styles.tblFooter}>
            <div className={styles.tblTotal}>
              <input
                ref={footerSelectRef}
                type="checkbox"
                className={styles.chk}
                checked={isUseCheckedAllPage && customerCheck.length === 0}
                onChange={handleFooterSelectAll}
                aria-label={t('customer_page.select_all_pages')}
                title={t('customer_page.select_all_pages')}
              />
              {t('customer_page.footer_total', { total: (data?.totalElements || 0).toLocaleString("vi-VN"), page: currentPage, pages: totalPages })}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <select value={rowsPerPage} onChange={handleChangeRowsPerPage} className={styles.sortSelect} style={{ padding: "5px 26px 5px 10px" }}>
                <option value={10}>{t('customer_page.per_page', { n: 10 })}</option>
                <option value={20}>{t('customer_page.per_page', { n: 20 })}</option>
                <option value={30}>{t('customer_page.per_page', { n: 30 })}</option>
                <option value={50}>{t('customer_page.per_page', { n: 50 })}</option>
              </select>
              <div className={styles.pagination}>
                <button className={styles.pgBtn} disabled={currentPage <= 1} onClick={() => handleChange(null, currentPage - 1)}>‹</button>
                {getPaginationPages().map((p, i) =>
                  p === "…"
                    ? <span key={i} style={{ fontSize: 12, color: "#9CA3AF", padding: "0 3px" }}>…</span>
                    : <button key={i} className={cn(styles.pgBtn, { [styles.on]: p === currentPage })} onClick={() => handleChange(null, p)}>{p}</button>
                )}
                <button className={styles.pgBtn} disabled={currentPage >= totalPages} onClick={() => handleChange(null, currentPage + 1)}>›</button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Confirm Delete Dialog */}
      {isOpenModalConfirmRemoveCus && (
        <div className={styles.confirmOverlay} onClick={() => handleToggleRemoveModal()}>
          <div className={styles.confirmBox} onClick={(e) => e.stopPropagation()}>
            <div className={styles.confirmIcon}>
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className={styles.confirmTitle}>
              {t("customer_management.confirm_delete_title")}
            </div>
            <div className={styles.confirmSub}>
              {t("customer_management.confirm_delete_message_1")}{" "}
              <b>{totalNumber > 0 ? totalNumber : 0}</b>{" "}
              {t("customer_management.confirm_delete_message_2")}
            </div>
            <div className={styles.confirmActions}>
              <button className={styles.confirmCancel} onClick={() => handleToggleRemoveModal()}>
                {t("common.btn.cancel")}
              </button>
              <button className={styles.confirmOk} onClick={handleSubmitRemoveCustomer}>
                {t("common.btn.delete")}
              </button>
            </div>
          </div>
        </div>
      )}

      {typeModalTag && (
        <ModalTagsBombot
          isRemove={typeModalTag === "edit"}
          handleClose={onCloseModal}
          setMessageType={setTypeMessage}
          customerAfterFilter={
            isUseCheckedAllPage
              ? []
              : (getSelectedCustomers().length > 0 ? getSelectedCustomers() : customerAfterFilter)
          }
          selectAllPages={isUseCheckedAllPage}
          activeSearch={buildFullSearchQuery(search, appliedConds)}
          selectedCount={totalNumber > 0 ? totalNumber : 0}
        />
      )}

      <FilterCustomerModal
        customerAll={customerAll}
        isOpen={isOpenModalFilter}
        handleClose={toggleModalFilter}
        onSubmitFilter={onSubmitFilter}
        searchVal={search}
      />

      {isOpenModalManageTag && (
        <TagsManagementModal
          isOpen={isOpenModalManageTag}
          handleClose={() => setIsOpenModalManageTag(false)}
          getData={() => getData({ page, size: rowsPerPage, search: buildFullSearchQuery(search, appliedConds), sort: sortVal })}
          getFanpage={getFanpage}
          fanpageSelected={fanpageSelected}
        />
      )}

      {!_.isNull(selectedTags) && (
        <TagsModal
          onClose={() => setSeletedTags(null)}
          isOpen={!_.isNull(selectedTags)}
          selectedTags={selectedTags?.tagList || []}
          customer={selectedTags?.customer || null}
          type={selectedTags?.type}
          tagsObj={tagsObj}
          handleRemoveTags={handleRemoveTags}
        />
      )}

      {/* Toast Copy */}
      <div className={`${styles.toast} ${toastMsg ? styles.show : ''}`}>
        <svg viewBox="0 0 14 14" fill="none"><path d="M2.5 7.5l3 3 6-6.5" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
        {toastMsg}
      </div>
    </>
  );
}

EnhancedTable.propTypes = {
  data: PropTypes.object,
  search: PropTypes.string,
  isSearch: PropTypes.bool,
  isPagination: PropTypes.bool,
  getData: PropTypes.func,
  handleGetData: PropTypes.func
};

EnhancedTable.defaultProps = {
  isPagination: true,
  isSearch: true,
  handleGetData: (f) => f,
  getData: (f) => f,
  data: {},
  search: null
};
